import { fn } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismNumberInput } from '@mylighthouse/prism-ember';
import type { CustomEmberTableColumn } from '@mylighthouse/prism-ember/types/components/prism/table';
import { t } from 'ember-intl';
import type { RecommendationStrategy } from 'lumen/models';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

type MinimumPriceDifferenceTableColumn = CustomEmberTableColumn & {
  hasWarning: boolean;
  id: number;
  isEditing: boolean;
  minimumPriceDifferenceChange: (dow: number, value: number | null) => void;
  strategy: RecommendationStrategy;
};

interface SettingsRecommendationsTdMinimumPriceDifferenceSignature {
  Args: {
    column: MinimumPriceDifferenceTableColumn;
    value: {
      formattedValue: string;
      rawValue: number;
    };
  };
}

export default class SettingsRecommendationsTdMinimumPriceDifference extends Component<SettingsRecommendationsTdMinimumPriceDifferenceSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  <template>
    {{#if @column.isEditing}}
      <PrismNumberInput
        @hasWarnings={{@column.hasWarning}}
        @inlineLabel={{this.hotelAndMarketService.hotel.currencySymbol}}
        @isSmall={{true}}
        @min={{0}}
        @onValueChange={{fn @column.minimumPriceDifferenceChange @column.id}}
        @placeholder={{t
          "pricing_assistant.recommendations.price_range.no_min"
        }}
        @removePadding={{true}}
        @value={{@value.rawValue}}
      />

    {{else}}
      {{@value.formattedValue}}
    {{/if}}
  </template>
}
